import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Image } from '@thd-olt-component-react/image';

const HeroImage = (props) => {
  const { options = {} } = props;
  let imageBackground = options.backgroundImage ? options.backgroundImage : '';
  imageBackground = imageBackground.replace(/^url\(['"]?([^'"]+)['"]?\)/, '$1');
  const { height, width, name, alt } = options;
  const imgClass = classNames({
    'img--block':height && width
  });
  if (options.URL) {
    return (
      <a
        className={classNames({
          triggerOverlay: options.openInModal,
          'tip-Opener': options.isToolTip
        })}
        data-overlay-type={options.relationship}
        data-tooltop={(options.isToolTip) ? options.URL : ''}
        href={options.URL}
        target={(options.targetBlank) ? '_blank' : ''}
        rel={(options.externalLink) ? 'nofollow' : ''}
      >
        <Image
          stretchy
          className={imgClass}
          src={imageBackground}
          id={name}
          alt={alt}
          height={height}
          width={width}
        />
      </a>
    );
  }
  return (
    <Image
      stretchy
      src={imageBackground}
      id={name}
      alt={alt}
      height={height}
      width={width}
      className={imgClass}
    />
  );
};

HeroImage.propTypes = {
  options: PropTypes.shape({
    textShadowNone: PropTypes.bool,
    backgroundImage: PropTypes.string,
    name: PropTypes.string,
    alt: PropTypes.string,
    isToolTip: PropTypes.bool,
    URL: PropTypes.string,
    openInModal: PropTypes.bool,
    targetBlank: PropTypes.bool,
    externalLink: PropTypes.bool,
    relationship: PropTypes.string,
  }).isRequired
};

export default HeroImage;
